import { StyleSheet, View } from "react-native";
import React, { ReactNode } from "react";

type TopIConProps = {
  icon: ReactNode;
  password?: boolean;
  totalScreens?: number;
  currentScreen?: number;
};

const Circle: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  return (
    <View
      style={{
        width: 6,
        height: 6,
        backgroundColor: isActive ? "#000000" : "#CAC9C7",
        borderRadius: 50,
      }}
    />
  );
};
const TopIconView: React.FC<TopIConProps> = ({
  icon,
  password = false,
  totalScreens,
  currentScreen,
}) => {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
      }}
    >
      {totalScreens && currentScreen ? (
        <>
          {Array.from({ length: totalScreens }).map((_, index) => (
            
            <React.Fragment key={index}>
              {index + 1 === currentScreen ? (
                <View style={styles.commonBorder}>{icon}</View>
              ) : (
                <>
                  {index + 1 < currentScreen ?
                    <View style={{ transform: [{ scaleX: (totalScreens - Math.abs(currentScreen - index)) * 0.1 }, { scaleY: (totalScreens - Math.abs(currentScreen - index)) * 0.1 }] }}>
                      <Circle isActive={true} />
                    </View> :
                    <View style={{ transform: [{ scaleX: (totalScreens - Math.abs(currentScreen - index)) * 0.1 }, { scaleY: (totalScreens - Math.abs(currentScreen - index)) * 0.1 }] }}>
                      <Circle isActive={false} />
                    </View>
                  }
                </>

              )}
            </React.Fragment>
          ))}
        </>
      ) : (
        <>
          {password ? (
            <>
              <Circle isActive={false} />
              <View style={styles.commonBorder}>{icon}</View>
            </>
          ) : (
            <>
              <View style={styles.commonBorder}>{icon}</View>
              <View style={{ transform: [{ scaleX: 12 }, { scaleY: 12 }] }}><Circle isActive={false} /></View>
            </>
          )}
        </>
      )}
    </View>
  );
};

export default TopIconView;

const styles = StyleSheet.create({
  commonBorder: {
    borderWidth: 0.5,
    borderColor: "#000000",
    width: 36,
    height: 36,
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
  },
});
